import { ChangeDetectionStrategy, Component, Type, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';

@Component({
  selector: 'ish-home-page',
  templateUrl: './home-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomePageComponent {
  private appFacade = inject(AppFacade);

  lazyPageComponent$: Observable<Type<unknown>> = this.appFacade.loadLazyComponent('page');
}
